module.exports = __webpack_public_path__ + "static/media/Nathalie_Gretillat_Relaxamento_profundo.3597c831.jpg";